import React, { useCallback } from 'react';
import { AdminDeletePageModalProps } from './admin-delete-page-modal-props';
import { AdminModal } from '../admin-modal';
import { AdminModalBody } from '../admin-modal-body';
import { AdminModalButtonFooter } from '../admin-modal-button-footer';
import { AdminModalHeader } from '../admin-modal-header';
import { AdminModalHeading } from '../admin-modal-heading';
import { AdminModalText } from '../admin-modal-text';
import { Button } from '@mint/ui';
import { popAdminModal } from '../../../actions';
import { useDeletePageMutation } from '../../../mutations';
import { useDispatch } from 'react-redux';

export const AdminDeletePageModal: React.FunctionComponent<
  AdminDeletePageModalProps
> = props => {
  const dispatch = useDispatch();

  const [deletePage] = useDeletePageMutation({
    id: props.page.id,
  });

  const onDeleteClick = useCallback(async () => {
    await deletePage();
    dispatch(popAdminModal());
  }, [deletePage]);

  const onCancelClick = useCallback(() => {
    dispatch(popAdminModal());
  }, [dispatch]);

  return (
    <AdminModal>
      <AdminModalHeader>
        <AdminModalHeading>Delete Page</AdminModalHeading>
      </AdminModalHeader>
      <AdminModalBody>
        <AdminModalText>
          {props.page.title ? (
            <>
              Are you sure you want to delete the page <b>{props.page.title}</b>
              ?
            </>
          ) : (
            'Are you sure you want to delete this page?'
          )}
        </AdminModalText>
      </AdminModalBody>
      <AdminModalButtonFooter>
        <Button onClick={onCancelClick}>Cancel</Button>
        <Button onClick={onDeleteClick} color="error">
          Yes, Delete Forever
        </Button>
      </AdminModalButtonFooter>
    </AdminModal>
  );
};
